import { createPageUrl } from '@/utils';

const MOBILE_SCHEME = 'com.mbv.igreja';
const NATIVE_AUTH_HOST = 'auth';
const NATIVE_RECOVERY_HOST = 'perfil';
const WEBSITE_ORIGIN = 'https://www.igrejambv.com.br';
const APP_LINK_AUTH_URL = `${WEBSITE_ORIGIN}/auth`;
const APP_LINK_RECOVERY_URL = `${WEBSITE_ORIGIN}/perfil`;
const WEBSITE_HOST = 'www.igrejambv.com.br';

function isNativePlatform() {
  if (typeof window === 'undefined') return false;
  if (typeof window.Capacitor?.isNativePlatform === 'function') {
    return window.Capacitor.isNativePlatform();
  }
  return false;
}

export function getRecoveryRedirectUrl() {
  if (typeof window === 'undefined') return createPageUrl('Perfil');

  if (isNativePlatform()) {
    const nativePlatform = String(window.Capacitor?.getPlatform?.() || '').toLowerCase();
    if (nativePlatform === 'android') {
      const appLink = new URL(APP_LINK_RECOVERY_URL);
      appLink.searchParams.set('mode', 'update');
      const deepLink = `${MOBILE_SCHEME}://${NATIVE_RECOVERY_HOST}?mode=update`;
      return `${WEBSITE_ORIGIN}/oauth-native-callback.html?app_link=${encodeURIComponent(appLink.toString())}&deep_link=${encodeURIComponent(deepLink)}`;
    }
    return `${MOBILE_SCHEME}://${NATIVE_RECOVERY_HOST}?mode=update`;
  }

  const url = new URL(`${window.location.origin}${createPageUrl('Perfil')}`);
  url.searchParams.set('mode', 'update');
  return url.toString();
}

export function getOAuthRedirectUrl() {
  if (typeof window === 'undefined') return createPageUrl('Perfil');

  if (isNativePlatform()) {
    const deepLink = `${MOBILE_SCHEME}://${NATIVE_AUTH_HOST}`;
    const nativePlatform = String(window.Capacitor?.getPlatform?.() || '').toLowerCase();
    if (nativePlatform === 'android') {
      return `${WEBSITE_ORIGIN}/oauth-native-callback.html?app_link=${encodeURIComponent(APP_LINK_AUTH_URL)}&deep_link=${encodeURIComponent(deepLink)}`;
    }
    return `${WEBSITE_ORIGIN}/oauth-native-callback.html?deep_link=${encodeURIComponent(deepLink)}`;
  }

  return `${window.location.origin}${createPageUrl('Perfil')}`;
}

export function parseAuthCallbackUrl(rawUrl) {
  if (!rawUrl) return null;

  let parsedUrl;
  try {
    parsedUrl = new URL(rawUrl);
  } catch (_error) {
    return null;
  }

  const queryParams = new URLSearchParams(parsedUrl.search || '');
  const hashParams = new URLSearchParams((parsedUrl.hash || '').replace(/^#/, ''));
  const getParam = (key) => hashParams.get(key) || queryParams.get(key) || '';

  const accessToken = getParam('access_token');
  const refreshToken = getParam('refresh_token');
  const code = getParam('code');
  const type = getParam('type');
  const mode = getParam('mode');
  const error = getParam('error');
  const errorDescription = getParam('error_description');
  const host = parsedUrl.host || '';
  const pathname = String(parsedUrl.pathname || '').replace(/\/+$/, '');
  const hasSessionTokens = Boolean(accessToken && refreshToken);
  const hasAuthCode = Boolean(code);
  const hasAuthError = Boolean(error);
  const isRecoveryPath = pathname === `/${NATIVE_RECOVERY_HOST}` || pathname.endsWith('/reset-password');
  const isAuthPath = pathname === `/${NATIVE_AUTH_HOST}`;
  const isWebsiteHost = host === WEBSITE_HOST;
  const isRecovery = type === 'recovery' || mode === 'update' || rawUrl.includes('/reset-password') || host === NATIVE_RECOVERY_HOST || isRecoveryPath;
  const isAuthCallback =
    hasSessionTokens ||
    hasAuthCode ||
    hasAuthError ||
    isRecovery ||
    host === NATIVE_AUTH_HOST ||
    isAuthPath ||
    (isWebsiteHost && (isAuthPath || isRecoveryPath));

  return {
    accessToken,
    refreshToken,
    code,
    error,
    errorDescription,
    isRecovery,
    isAuthCallback,
  };
}
